import React from 'react'

import { Cube } from '../../geometries/Cube'
import { TextItem } from '../TextItem'

import { getTableTextWidth } from './Table'
import { degreesToRadians } from '../../helpers'
import { getContrastColor } from 'sections/options/sections/RestaurantDesigner/helpers'

export const SquaredTable = ({ position, color, rotation, height = 60, width = 60, caption }) => {
	return (
		<group position={position} scale={[1, 1, 1]} rotation={[0, degreesToRadians(rotation), 0]} castShadow receiveShadow>
			<Cube color={color} position={[width / -2 + 5, 20, height / 2 - 5]} size={[5, 40, 5]} />
			<Cube color={color} position={[width / 2 - 5, 20, height / 2 - 5]} size={[5, 40, 5]} />
			<Cube color={color} position={[width / -2 + 5, 20, height / -2 + 5]} size={[5, 40, 5]} />
			<Cube color={color} position={[width / 2 - 5, 20, height / -2 + 5]} size={[5, 40, 5]} />
			<Cube color={color} position={[0, 40, 0]} size={[width, 2.5, height]} />
			{caption && 
				<TextItem
					key={`${caption}_caption`}
					width={25}
					height={5}
					rotation={0}
					text={caption}
					position={[getTableTextWidth(caption), 38, -7]}
					color={getContrastColor(color)}
					hideShadow
				/>
			}
		</group>
	)
}
